import { render, staticRenderFns } from "./NanoLoanDashboard.vue?vue&type=template&id=fbdbac22&scoped=true"
import script from "./NanoLoanDashboard.vue?vue&type=script&lang=js"
export * from "./NanoLoanDashboard.vue?vue&type=script&lang=js"
import style0 from "./NanoLoanDashboard.vue?vue&type=style&index=0&id=fbdbac22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdbac22",
  null
  
)

export default component.exports